import { User } from 'services/user'
import S3FileUpload from 'react-s3'
import { FetchOptions } from './api.types'

enum Methods {
  GET = 'GET',
  POST = 'POST',
  PUT = 'PUT',
  DELETE = 'DELETE',
  PATCH = 'PATCH'
}

export class Fetch {
  private onError: (error: Error) => void
  private onFetchStart: () => void
  private onFetchEnd: () => void

  constructor (init: {
    onError: (error: Error) => void
    onFetchStart: () => void
    onFetchEnd: () => void
  }) {
    this.onError = init.onError
    this.onFetchStart = init.onFetchStart
    this.onFetchEnd = init.onFetchEnd
  }

  private get headers (): HeadersInit {
    const { tokenType, accessToken } = User.token
    const headerAuth = `${tokenType} ${accessToken}`
    return {
      'Content-Type': 'application/json',
      Authorization: headerAuth
    }
  }

  private parseJson = async (response: Response) => {
    try {
      const text = await response.text()
      return text ? JSON.parse(text) : {}
    } catch (error) {
      console.error('ERROR PARSING RESPONSE BODY:', error)
      throw new Error(error)
    }
  }

  private fetch = async (
    input: RequestInfo,
    init?: RequestInit,
    options?: FetchOptions
    ) => {
      !options?.silentProcess && this.onFetchStart()
      try {
        const response = { ok: true, status: 200 }
        const apiResponse = await window.fetch(input, {
          headers: this.headers,
          method: Methods.GET,
          ...init
        })
        response.ok = apiResponse.ok
        response.status = apiResponse.status
        const resBody = await this.parseJson(apiResponse)
        if (response.ok) {
          return resBody
        } else {
          throw new Error(JSON.stringify({ ...resBody, ...response }))
        }
      } catch (error) {
        this.onError(error);
        throw error;
      } finally {
        !options?.silentProcess && this.onFetchEnd()
      }
  }

  public get = async (url: string, options?: FetchOptions): Promise<any> => {
    return await this.fetch(url, undefined, options)
  }
  public post = async (
    url: string,
    body: any,
    options?: FetchOptions
  ): Promise<any> => {
    return await this.fetch(
      url,
      {
        method: Methods.POST,
        body: JSON.stringify(body)
      },
      options
    )
  }
  public put = async (
    url: string,
    body: any,
    options?: FetchOptions
  ): Promise<any> => {
    return await this.fetch(
      url,
      {
        method: Methods.PUT,
        body: JSON.stringify(body)
      },
      options
    )
  }
  public patch = async (
    url: string,
    body: any,
    options?: FetchOptions
  ): Promise<any> => {
    return await this.fetch(
      url,
      {
        method: Methods.PATCH,
        body: JSON.stringify(body)
      },
      options
    )
  }
  public delete = async (url: string, options?: FetchOptions): Promise<any> => {
    return await this.fetch(
      url,
      {
        method: Methods.DELETE
      },
      options
    )
  }
  public upload = async (
    file: File,
    config: object
  ): Promise<{ location: string }> => {
    this.onFetchStart()
    try {
      return await S3FileUpload.uploadFile(file, config)
      //return await this.uploadFileSigned(file, config)
    } catch (error) {
      this.onError(error)
    } finally {
      this.onFetchEnd()
    }
  }

  public uploadSigned = async (
      file , res
  ): Promise<{ location: string }> => {
    const params = {
      method: res.httpMethod,
      body: file
    }

    const data = await fetch(res.url, params)
    if (!data.ok) return Promise.reject(data)
    return Promise.resolve({
      location: res.location
    })
  }

}
